<div class="main-container">
    <app-loader [isLoading]="isLoading"></app-loader>
    <div class="inquiry-container">
        <div>
            <app-customer-boooking-header [data]="headerData"></app-customer-boooking-header>
        </div>
        <div class="wbg">
            <div *ngIf="!isMobileView" class="row">
                <label [hidden]="true">{{isValidData()}}</label>
                <div class="col-8">
                    <app-inquiry-form class="w-100" [flexFieldData]="flexFieldData" [isFlexfieldEnable]="isFlexfieldEnable"
                        [showVideoConf]="showVideoConf" [isEmailFieldRequired]="isEmailFieldRequired" [isSubmitted]="isSubmitted"></app-inquiry-form>
                    <div class="row m-0 mt-5 mb-2">
                        <button class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                        <button class="btn-nxt ml-1" (click)="goNext()">Book</button>
                    </div>
                </div>
                <div class="col-4">
                    <app-booking-detail class="h-100" [bookingData]="bookingDetails" [flexData]="bookingFlexFieldDetails"
                    [showVideoConf]="showVideoConf" [isMemberVisible]="isMemberVisible" [isCategoryVisible]="isCategoryVisible" [isInquiry]="false"></app-booking-detail>
                </div>
            </div>
            <div *ngIf="isMobileView" class="row">
                <div class="col-12">
                    <app-inquiry-form class="w-100" [flexFieldData]="flexFieldData" [isFlexfieldEnable]="isFlexfieldEnable"
                        [showVideoConf]="showVideoConf" [isEmailFieldRequired]="isEmailFieldRequired" [isSubmitted]="isSubmitted"></app-inquiry-form>
                    <div class="row m-0 mt-5 mb-2">
                        <button class='btn-cancel mr-1' (click)="goBack()">Cancel</button>
                        <button class="btn-nxt ml-1" (click)="goNext()">Book</button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div>
        <app-footer-powered-by-image></app-footer-powered-by-image>
    </div>

</div>
